
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateSupplierDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(200)]),
    zipcode: new FormControl<string | undefined>(undefined, [Validators.maxLength(10)]),
    city: new FormControl<string | undefined>(undefined, [Validators.maxLength(200)]),
    street: new FormControl<string | undefined>(undefined, [Validators.maxLength(50)]),
    canton: new FormControl<string | undefined>(undefined, [Validators.maxLength(50)]),
})
;
}
      